<template><div></div></template>

<script>
import loadScript from 'load-script-once'

export default {
  name: 'KakaoMap',
  props: {
    value: { // positions v-model {data:[], sdata:{}, edata:{} }
      type: Object,
      default: function () {
        return { data: [], sdata: {}, edata: {} }
      }
    },
    lastGps: {
      type: Object,
      default: function () {
        return { y: null, x: null }
      }
    }
  },
  data: () => ({
    map: null,
    kakaoMap: null,
    markers: [],
    polyline: null,
    kakaoAppKey: process.env.VUE_APP_KAKAO_APP_KEY,
    center: { lat: 33.4423524, lng: 126.5715475 }
  }),
  watch: {
    level() {
      if (!this.map) {
        return
      }
      this.map.setLevel(this.level)
    },
    value: {
      handler() {
        // 선택 초기화 시 -> 마커 초기화
        if(this.value == null) {
          if (this.markers) {
            for (let i = 0; i < this.markers.length; i++) {
              this.markers[i].setMap(null)
            }
            this.markers = []
          }
          if (this.polyline) {
            this.polyline.setMap(null)
            this.polyline = null
          }

          return
        }

        // 데이터 없을시 마커 정리, 센터 변경 -> 종료
        if (!this.map || (this.value.data.length === 0 && !this.value.sdata)) {
          this.map.setCenter(new this.kakaoMap.maps.LatLng(this.center.lat, this.center.lng))
          return
        }


        // 기존 마커 및 라인 정리 하기
        if (this.markers) {
          for (let i = 0; i < this.markers.length; i++) {
            this.markers[i].setMap(null)
          }
          this.markers = []
        }
        if (this.polyline) {
          this.polyline.setMap(null)
          this.polyline = null
        }

        let linePath = []
        let imageSrc = null
        let imageOption = null
        let position = null
        let lastPosition = null

        let data = this.value.data
        let sdata = (this.value.sdata) ? this.value.sdata : null
        let edata = (this.value.edata) ? this.value.edata : null

        if (data.length != 0) {
          // 진행 화살표 이미지
          for (var i = 0; i < data.length; i++) {
            // 화살표 계산용
            let imageSize = new this.kakaoMap.maps.Size(10, 10)
            let start_latitude = (i > 0) ? data[i - 1].lat : sdata.lat
            let start_longitude = (i > 0) ? data[i - 1].lng : sdata.lng
            let stop_latitude = data[i].lat
            let stop_longitude = data[i].lng
  
            // 방향 계산
            var dir = (Math.atan2(stop_longitude - start_longitude, stop_latitude - start_latitude) * 180) / Math.PI
            // 화살표 표기용
            if (dir >= -45 && dir < 45) {
              imageSrc = (require(`../assets/mapicon/top.png`))
              imageOption = { offset: new this.kakaoMap.maps.Point(5, 7) }
            } else if (dir >= 45 && dir < 135) {
              imageSrc = (require(`../assets/mapicon/right.png`))
              imageOption = { offset: new this.kakaoMap.maps.Point(5, 6) }
            } else if (dir >= 135 && dir <= 180) {
              imageSrc = (require(`../assets/mapicon/down.png`))
              imageOption = { offset: new this.kakaoMap.maps.Point(6, 6) }
            } else if (dir >= -180 && dir < -135) {
              imageSrc = (require(`../assets/mapicon/down.png`))
              imageOption = { offset: new this.kakaoMap.maps.Point(5, 6) }
            } else {
              imageSrc = (require(`../assets/mapicon/left.png`))
              imageOption = { offset: new this.kakaoMap.maps.Point(3, 8) }
            }
  
            var markerImage = new this.kakaoMap.maps.MarkerImage(imageSrc, imageSize, imageOption)
            position = new this.kakaoMap.maps.LatLng(data[i].lat, data[i].lng)
            var marker = new this.kakaoMap.maps.Marker({
              map: this.map, // 마커를 표시할 지도
              position: position, // 마커를 표시할 위치
              title: data[i].lat + ', ' + data[i].lng, // 마커의 타이틀, 마커에 마우스를 올리면 타이틀이 표시됩니다
              image: markerImage // 마커 이미지
            })
            linePath.push(position)
            this.markers.push(marker)
            lastPosition = position
          }
        }

        // 시작 마커 처리
        if (sdata) {
          let sMarker = new this.kakaoMap.maps.Marker({
            map: this.map, // 마커를 표시할 지도
            position: new this.kakaoMap.maps.LatLng(sdata.lat, sdata.lng), // 마커를 표시할 위치
            title: sdata.address, // 마커의 타이틀, 마커에 마우스를 올리면 타이틀이 표시됩니다
            image: new this.kakaoMap.maps.MarkerImage(require(`../assets/mapicon/0.png`), new this.kakaoMap.maps.Size(24, 35), { offset: new this.kakaoMap.maps.Point(13, 30) }) // 마커 이미지
          })
          this.markers.push(sMarker)
          linePath.unshift(new this.kakaoMap.maps.LatLng(sdata.lat, sdata.lng))
        }

        // 끝 마커 처리
        if (edata.address) {
          let eMarker = new this.kakaoMap.maps.Marker({
            map: this.map, // 마커를 표시할 지도
            position: new this.kakaoMap.maps.LatLng(edata.lat, edata.lng), // 마커를 표시할 위치
            title: edata.address, // 마커의 타이틀, 마커에 마우스를 올리면 타이틀이 표시됩니다
            image: new this.kakaoMap.maps.MarkerImage(require(`../assets/mapicon/999.png`), new this.kakaoMap.maps.Size(24, 35), { offset: new this.kakaoMap.maps.Point(13, 30) }) // 마커 이미지
          })
          this.markers.push(eMarker)
          linePath.push(new this.kakaoMap.maps.LatLng(edata.lat, edata.lng))

          // center 바꿈
          this.map.setCenter(new this.kakaoMap.maps.LatLng(edata.lat, edata.lng))
        } else {
          let eMarker = new this.kakaoMap.maps.Marker({
            map: this.map, // 마커를 표시할 지도
            position: lastPosition, // 마커를 표시할 위치
            title: '운행중', // 마커의 타이틀, 마커에 마우스를 올리면 타이틀이 표시됩니다
            image: new this.kakaoMap.maps.MarkerImage(require(`../assets/mapicon/998.png`), new this.kakaoMap.maps.Size(24, 35), { offset: new this.kakaoMap.maps.Point(13, 30) }) // 마커 이미지
          })
          this.markers.push(eMarker)
          linePath.push(lastPosition)

          // center 바꿈
          if (lastPosition) {
            this.map.setCenter(lastPosition)
          } else {
            this.map.setCenter(new this.kakaoMap.maps.LatLng(sdata.lat, sdata.lng))
          }
        }

        // 지도에 표시할 선을 생성합니다
        if (linePath) {
          this.polyline = new this.kakaoMap.maps.Polyline({
            path: linePath, // 선을 구성하는 좌표배열 입니다
            strokeWeight: 5, // 선의 두께 입니다
            strokeColor: '#FFAE00', // 선의 색깔입니다
            strokeOpacity: 0.7, // 선의 불투명도 입니다 1에서 0 사이의 값이며 0에 가까울수록 투명합니다
            strokeStyle: 'solid' // 선의 스타일입니다
          })
          this.polyline.setMap(this.map)
        }
      }
    },

    lastGps: {
      handler() {
        // 선택 초기화 시 -> 마커 초기화
        if(this.lastGps == null) {
          if (this.markers) {
            for (let i = 0; i < this.markers.length; i++) {
              this.markers[i].setMap(null)
            }
            this.markers = []
          }
          if (this.polyline) {
            this.polyline.setMap(null)
            this.polyline = null
          }

          return
        }

        // 기존 마커 및 라인 정리 하기
        if (this.markers) {
          for (let i = 0; i < this.markers.length; i++) {
            this.markers[i].setMap(null)
          }
          this.markers = []
        }
        if (this.polyline) {
          this.polyline.setMap(null)
          this.polyline = null
        }

        let lMarker = new this.kakaoMap.maps.Marker({
          map: this.map, // 마커를 표시할 지도
          position: new this.kakaoMap.maps.LatLng(this.lastGps.y, this.lastGps.x), // 마커를 표시할 위치
          title: this.lastGps.addr + ' (' + this.lastGps.c_date + ')', // 마커의 타이틀, 마커에 마우스를 올리면 타이틀이 표시됩니다
          image: new this.kakaoMap.maps.MarkerImage(require(`../assets/mapicon/999.png`), new this.kakaoMap.maps.Size(24, 35), { offset: new this.kakaoMap.maps.Point(13, 30) }) // 마커 이미지
        })

        this.markers.push(lMarker)
        this.map.setCenter(new this.kakaoMap.maps.LatLng(this.lastGps.y, this.lastGps.x))
      }
    }
  },
  mounted() {
    loadScript(`//dapi.kakao.com/v2/maps/sdk.js?autoload=false&appkey=${this.kakaoAppKey}`)
      .then(() => {
        this.kakaoMap = window.kakao
        this.kakaoMap.maps.load(() => {
          this.render()
          this.$emit('load', this.map)
        })
      })
      .catch(err => {
        console.error(err)
      })
  },
  methods: {
    render() {
      const options = { //지도를 생성할 때 필요한 기본 옵션
        center: new this.kakaoMap.maps.LatLng(this.center.lat, this.center.lng),
        level: this.level, //지도의 레벨(확대, 축소 정도)
      }
      this.map = new this.kakaoMap.maps.Map(this.$el, options) //지도 생성 및 객체 리턴
    }
  }
}
</script>

<style scoped></style>
